<template>
  <hearbar bgcolor="white">
    <template v-slot:left-icon>
      <van-icon name="arrow-left" @click="step == 1 ? $router.go(-1) : (step = 1)" />
    </template>

    <template #default>
      <div>
        <h3>{{ $fanyi('提出订单') }}</h3>
        <p>{{ $fanyi('订单号') }}: <span>{{ orderdata.order_sn }}</span></p>
      </div>
    </template>
    <template v-slot:right-icon>
      <div class="bianji" @click="edit">
        {{ showedit == false ? $fanyi("编辑") : $fanyi("完成") }}
      </div>
    </template>
  </hearbar>


  <!-- 提出订单页面 -->
  <div class="placeanorder">

    <!-- 商品列表 -->
    <div class="shoplist" :class="{ maxheight: putdown }">
      <!-- 店铺 -->
      <div class="shopitem" v-for="item in orderdata.detail" :key="item.shop_id">
        <h3> <span>{{ $fanyi('店铺') }} :</span> {{ item.shop_name }} </h3>

        <!-- 商品 -->
        <div class="gooditem" :class="{ borderbottom: index > 0 }" v-for="(goodsitem, index) in item.list"
          :key="goodsitem.goods_id">
          <div class="Content">
            <input v-if="showedit" class="checkbox-box" @change="goodscheckboxchange(item)" type="checkbox"
              v-model="goodsitem.goodschecked" />
            <!-- 图片 -->
            <div class="img-box" @click="$fun.toCommodityDetails({
              goods_id: goodsitem.goods_id,
              shop_type: goodsitem.shop_type,
            }
            );">
              <van-image :src="goodsitem.pic">
                <template v-slot:loading>
                  <van-loading type="spinner" size="20" />
                </template>
              </van-image>
            </div>
            <!--右侧商品信息  -->
            <div class="rightgoodsinfo">
              <!-- 商品描述和删除 -->
              <div class="Description">
                <p class="text">{{ goodsitem.goods_title }}</p>
                <img src="../../assets/cart/delete_0.svg" alt="" @click="deleteitem(goodsitem.cart_id)" />
              </div>
              <!-- 商品规格 -->
              <div class="Commodityspecification" @click="specificationspopupdom.open(goodsitem, 'temporary')">
                <p>{{ goodsitem.text }}</p>
                <img src="../../assets/cart/expansion.svg" alt="" />
              </div>
              <!-- <div v-else class="Commodityspecification" @click="specificationspopupdom.open(goodsitem, 'car1')">
                <p>{{ goodsitem.text }}</p>

                <img src="../../assets/cart/expansion.svg" alt="" />
              </div> -->
              <!-- 价格 -->
              <div class="price">
                <span class="dollar">
                  ${{
                    $fun.EURNumSegmentation(
                      $fun.ceil(goodsitem.price * $store.state.exchangeRate)
                    )
                  }}
                </span>
                <span class="RMB">
                  (￥{{ $fun.RMBNumSegmentation(goodsitem.price) }})
                </span>
              </div>
            </div>
          </div>

          <!-- 总价 -->
          <div class="totalprice">
            <div class="left-price">
              <span class="title">{{ $fanyi("总价") }}:</span>
              <!-- <span class="dollar"> $3.03( 21.00¥)</span> -->
              <span class="dollar">
                ${{
                  $fun.EURNumSegmentation(
                    $fun.ceil(
                      goodsitem.price *
                      goodsitem.num *
                      $store.state.exchangeRate
                    )
                  )
                }}

              </span>

              <span class="RMB">
                (￥{{
                  $fun
                    .RMBNumSegmentation(goodsitem.price * goodsitem.num)
                    .toFixed(2)
                }})
              </span>
            </div>
            <div class="right-input">
              <van-stepper @change="changeinput(2, goodsitem)" v-model="goodsitem.num" :min="1" integer />
            </div>
          </div>
          <!-- 附加服务 -->
          <div class="Additionalservices" @click="additionalservicesdom.open(goodsitem.option_old, goodsitem)">
            <p v-if="goodsitem.option.length == 0">{{ $fanyi('点击选择附加服务') }}</p>
            <p v-else class="optiontext">
              <span v-show="i.checked == true" v-for="(i) in goodsitem.option" :key="i.id">
                {{ i.tag }}
              </span>
            </p>
            <img src="../../assets/tichuorder/addservice.svg" alt="">

          </div>
          <!-- 备注 -->
          <div class="Remarks">
            <input @blur="inputblur(goodsitem)" type="text" :placeholder="$fanyi('备注栏')"
              v-model="goodsitem.user_postscript" />
          </div>
        </div>

      </div>

      <div class="foot-box">
        <div v-if="putdown == false" @click="putdown = !putdown">
          <span>Open</span>
          <img src="../../assets/tichuorder/open.svg" alt="">
        </div>
        <div v-else @click="putdown = !putdown">
          <span>Put away</span>
          <img src="../../assets/tichuorder/putdown.svg" alt="">
        </div>

      </div>
    </div>

    <!-- 我的地址：提出订单前选择收货地址，提交时带 address_id -->
    <OrderAddress
      :editable="true"
      :order-sn="orderdata.order_sn || ''"
      :order-address="orderAddressInfo"
      @change="onAddressChange"
    />

    <!-- 订单备注 -->
    <div class="orderRemarks">
      <h2>{{ $fanyi('订单备注') }}</h2>
      <p>{{ $fanyi('请写下您对产品的任何附加服务或特殊要求，例如定制包装或产品定制有经验的经纪人会与你联系，讨论细节。') }}</p>


      <textarea name="" class="beizhu" :placeholder="$fanyi('备注将同步展示给代理人员')" v-model="client_remark"></textarea>

    </div>



    <!--产品总支出 -->
    <Producttotal :pricedata="pricedata" />

  </div>
  <!-- 商品规格 -->
  <specificationspopup @renewdata="Updata" ref="specificationspopupdom" />
  <!-- 附加服务组件 -->
  <additionalservices ref="additionalservicesdom" />
  <!-- 添加商品弹层组件 -->
  <additiveproduct @addData="addToDataProcessing" ref="additiveproductdom" />
  <!-- 底部操作栏 -->
  <div class="footercaozuolan" v-if="showedit == false">
    <!-- 附加产品 -->

    <div class="Additionalproductbox">

      <div class="leftproduct" @click="addproduct">
        <img src="../../assets/tichuorder/additionalproduct.svg" alt="">
        <span>{{ $fanyi('追加商品') }}</span>
      </div>
      <div class="quantity">{{ $fanyi('数量总计') }} <span>{{ Totalquantity }}</span></div>

    </div>
    <!-- 底部提出订单操作栏 -->
    <div class="tichu-box">

      <!-- 总价 -->
      <div class="totalprice">

        <div class="title">{{ $fanyi('总价') }}:</div>
        <div class="price">
          <p class="dollar">${{ $fun.EURNumSegmentation(
            $fun.ceil(
              totalPrice *
              $store.state.exchangeRate
            )
          ) }}</p>
          <p class="RMB"> (￥{{
            $fun
              .RMBNumSegmentation(totalPrice)
              .toFixed(2)
          }})</p>
        </div>
      </div>

      <!-- 临时保存 -->
      <div class="Temporarypreservation">
        <img src="../../assets/tichuorder/temporarysave.svg" alt="">
        <p @click="Placeanorder(10)">{{ $fanyi('临时保存') }}</p>
      </div>
      <!-- 提出 -->
      <div class="Placeanorder" @click="Placeanorder(20)">{{ $fanyi('提出订单') }}</div>
    </div>

  </div>

  <!-- 点击编辑底部操作栏 -->
  <div class="editfooterbox" v-else>
    <!-- 全选 -->
    <div class="allcheckbox">
      <div class="left-check">
        <input class="checkbox-box" @change="allcheckchange()" type="checkbox" v-model="allchecked" />
        <span>{{ $fanyi('全选/取消') }}</span>
      </div>

      <div class="Totalquantity">
        {{ $fanyi('数量总计') }}:
        <span>{{ Totalquantity }}</span>
      </div>

    </div>
    <!-- 删除，加入商品库-->
    <div class="caozuobox">


      <div class="delete" @click="Operation('delete')">{{ $fanyi('删除') }}</div>
      <div class="addgoods" @click="Operation('add')">{{ $fanyi("加入商品库") }}</div>
    </div>

  </div>

  <van-dialog id="deletedialong" v-model:show="showdelete" title="标题" show-cancel-button>
    <!-- default	自定义内容 title	自定义标题footer -->
    <template #title>
      <span>{{
        $fanyi("删除")
      }}</span>


      <img @click="showdelete = false" src="../../assets/cart/close.svg" alt="" />
    </template>
    <template #default>
      <!-- 单个 -->
      <p style="justify-content: flex-start">
        {{ $fanyi("是否删除所选商品?") }}
      </p>
    </template>

    <template #footer>
      <div class="deletefooter">

        <div class="delete" @click="confirmdelete">
          {{ $fanyi("删除") }}
        </div>
        <div class="cancel" @click="showdelete = false">
          {{ $fanyi("取消") }}
        </div>
      </div>
    </template>
  </van-dialog>
</template>
<script setup>
import { getCurrentInstance, ref, computed } from 'vue'
import { useRoute } from 'vue-router';
import hearbar from "../../components/headGoBack/index.vue";
import { showLoadingToast, showFailToast, closeToast, showToast, } from 'vant'
import Producttotal from './components/Producttotal.vue'
import additionalservices from './components/additionalservices.vue'
import specificationspopup from "../cart/components/specificationspopup.vue";
import additiveproduct from './components/additiveproduct.vue'
import OrderAddress from './components/OrderAddress.vue'
import { validateAddress } from '@/utlis/addressValidate'
import { useStore } from 'vuex'

// showToast, showFailToast,  showLoadingToast, closeToast,showSuccessToast
const route = useRoute()
const store = useStore()
const { proxy } = getCurrentInstance()
const showedit = ref(false); // 是否显示编辑按钮
const orderdata = ref({}) // 提出订单数据s
const pricedata = ref()// 价额数据
const putdown = ref(false)// 是否展示全部列表
const specificationspopupdom = ref('')// 商品规格dom
const additionalservicesdom = ref('')// 附加服务弹层dom
const additiveproductdom = ref('')//添加商品弹层呢dom
const client_remark = ref('') // 订单备注
const allchecked = ref('')// 全选状态
const Selectedarr = ref([]) // 选中的删除数组
const showdelete = ref(false)// 删除弹窗
const Totalquantity = ref(0)// 数量总计
const totalPrice = ref(0)//总价
const cartid = ref('')// 单删的商品id
const logistics = ref('') //国际物流
// 收货地址 id：地址模块选中后写入，提出订单时随 orderCreate 提交（对齐 PC）
const address_id = ref('')
// 客户当前点选的完整地址对象：提出订单前做格式校验用
const selectedAddress = ref(null)

/**
 * 把后端返回的地址规整成可用对象
 * 空数组 / null / 空字段 → null，避免地址组件误当成有地址
 */
const normalizeAddress = (addr) => {
  if (!addr || typeof addr !== 'object' || Array.isArray(addr)) return null
  const keys = ['contacts', 'address', 'city', 'zip_code', 'mobile', 'company', 'state', 'email']
  const hasValue = keys.some((key) => {
    const val = addr[key]
    return val !== undefined && val !== null && String(val).trim() !== ''
  })
  return hasValue ? addr : null
}

/**
 * 订单收货地址回显数据源（对齐 PC orderAddressInfo）
 * 兼容 consignee_address / receive / orderAddress 等多种字段位置
 */
const orderAddressInfo = computed(() => {
  const datas = orderdata.value || {}
  return (
    normalizeAddress(datas.consignee_address) ||
    normalizeAddress(datas.receive) ||
    normalizeAddress(datas.orderAddress && datas.orderAddress.consignee_address) ||
    normalizeAddress(datas.result && datas.result.consignee_address) ||
    normalizeAddress(datas.result && datas.result.receive) ||
    null
  )
})

/**
 * 地址模块切换回调：记下 id + 完整对象，提交时校验并传 address_id
 */
const onAddressChange = (address) => {
  // 没有 id 无法提交 address_id，直接忽略
  if (!address || address.id == null || address.id === '') return
  address_id.value = address.id
  selectedAddress.value = address
}

/**
 * 校验收货地址是否已选择且格式合法（提出订单拦截，临时保存不拦）
 * 必须有可提交的 address_id（来自地址簿选中），规则与支付页一致
 */
const checkAddressSelected = () => {
  const address = selectedAddress.value || orderAddressInfo.value
  const id = address_id.value || (address && address.id)
  if (!address || !id) {
    showToast(proxy.$fanyi('请先选择收货地址'))
    return false
  }
  const errorMsg = validateAddress(address, proxy.$fanyi)
  if (errorMsg) {
    showToast(proxy.$fanyi('收货地址不完整') + '：' + errorMsg)
    return false
  }
  address_id.value = id
  return true
}

/** 重新拉预览/详情时清空上次选中的地址，避免沿用旧 id */
const resetSelectedAddress = () => {
  address_id.value = ''
  selectedAddress.value = null
}

/**
 * 详情接口没带地址时，单独请求 orderAddress 写回 consignee_address（对齐 PC ensureOrderAddress）
 * 保证地址模块能回显并匹配出 address_id
 */
const ensureOrderAddress = async (order_sn) => {
  if (!order_sn) return
  // 详情已经带了可用地址就不重复请求
  if (orderAddressInfo.value) return
  try {
    const res = await proxy.$api.orderAddress({ order_sn })
    const data = res && res.data
    if (!data) return
    const addr =
      normalizeAddress(data.consignee_address) ||
      normalizeAddress(data)
    if (addr) {
      orderdata.value = {
        ...orderdata.value,
        consignee_address: addr,
      }
    }
  } catch (e) {
    // 地址兜底失败不影响其它内容
  }
}

// type=temporary  说明书临时保存的订单
showLoadingToast({
  duration: 0,
  message: proxy.$fanyi("加载中..."),
  forbidClick: true,
  loadingType: "spinner",
});


// 获取订单详情（临时单 / 修改订单回显）
const getorderDetail = async () => {
  // 重新拉详情时先清空上次点选，避免沿用旧 address_id
  resetSelectedAddress()
  const res = await proxy.$api.orderDetail({
    order_sn: route.query.order_sn
  })
  closeToast()
  if (res.code != 0) {
    showFailToast(proxy.$fanyi(res.msg))
    return
  }
  orderdata.value = res.data
  pricedata.value = res.data.order_money_group
  orderdata.value.exchange_rate = Number(orderdata.value.exchange_rate)
  // 将价格区间转化为 数组
  orderdata.value.detail.forEach((item) => {
    item.list.forEach((i) => {
      i.price_range = JSON.parse(i.price_range)
      i.text = ''
      i.goodschecked = false

    })
  })
  // 详情没带地址时兜底拉取，供地址模块回显
  await ensureOrderAddress(route.query.order_sn)
  internationalLogisticsTransportation()
  Statisticalquantity()
  console.log(res);
}
// 获取数据订单预览（购物车 / 商品库提出）
const getorderPreview = async () => {

  console.log(route.query.iscomm);
  // 重新拉预览时清空上次点选的地址
  resetSelectedAddress()
  // 如果iscomm 为true 说名是商品库  inventory_id
  let datas = {

  }
  if (route.query.iscomm) {
    datas.inventory_id = route.query.id
  } else {
    datas.cat_id = route.query.id
  }
  const res = await proxy.$api.orderPreview(datas)
  closeToast()
  if (res.code != 0) {
    showFailToast(proxy.$fanyi(res.msg))
    return
  }
  orderdata.value = res.data
  pricedata.value = res.data.order_money_group
  orderdata.value.exchange_rate = Number(orderdata.value.exchange_rate)

  // 获取国际物流方式

  // 将价格区间转化为 数组
  orderdata.value.detail.forEach((item) => {
    item.list.forEach((i) => {
      i.price_range = JSON.parse(i.price_range)
      i.text = ''
      i.goodschecked = false

    })
  })
  internationalLogisticsTransportation()
  Statisticalquantity()

}
if (route.query.order_sn) {
  getorderDetail()
} else {
  getorderPreview()
}


// 获取物流方式
const internationalLogisticsTransportation = async () => {
  const data = await proxy.$api.internationalLogisticsTransportation()
  console.log(data.data[0].name);
  logistics.value = data.data[0].name
}

const Statisticalquantity = () => {
  let checkarr = []
  // 商品总数
  Totalquantity.value = 0
  // 总价
  totalPrice.value = 0
  // 选中的商品
  Selectedarr.value = []
  orderdata.value.detail.forEach((item) => {
    item.list.forEach((i) => {
      Totalquantity.value += i.num
      totalPrice.value += Number(i.price) * Number(i.num);
      if (i.goodschecked == true) {
        // 把选中的goodid存起来
        Selectedarr.value.push(i.cart_id)
      }
      // 规格筛选拼接
      i.detail.forEach((detailitem) => {
        i.text += detailitem.key + ":" + " " + detailitem.value + " ";
      });
    })
    checkarr.push(item.list.every((ind) => ind.goodschecked == true))

  })

  if (checkarr.every((i) => i == true)) {
    allchecked.value = true
  } else {
    allchecked.value = false
  }
}
// 点击编辑按钮
const edit = () => {
  showedit.value = !showedit.value;
};
// 数量发生变化
const changeinput = async (type, goodsitem) => {


  //  首先确保是数组 然后 进行区间判断

  if (goodsitem.price_range.constructor == Array) {
    goodsitem.price_range.forEach((item, ind) => {
      if (
        goodsitem.num < goodsitem.price_range[ind + 1]
          ? goodsitem.price_range[ind + 1].startQuantity
          : true && goodsitem.num >= item.startQuantity
      ) {
        goodsitem.price = item.price;
      } else if (goodsitem.num < goodsitem.price_range[0].startQuantity) {
        goodsitem.price = goodsitem.price_range[0].price;
      }
    });
  }
  // 如果传入的type 是2 说明是输入框触发，
  if (type == 2) {
    // 然后发送请求修改后台价格
    calculateOrder()
    Statisticalquantity();
  }
};

// 计算价格
const calculateOrder = async () => {
  let data = []

  orderdata.value.detail.forEach((item) => {
    item.list.forEach((i) => {
      data.push(i)

    })
  })
  const res = await proxy.$api.calculateOrder({ data: JSON.stringify(data) });
  if (res.code != 0) {
    showFailToast(proxy.$fanyi(res.msg));
    return;
  }
  pricedata.value = res.data
}
// 修改完规格后数据更新 
const Updata = (goods, obj, detailsImg) => {

  orderdata.value.detail.forEach((item) => {
    item.list.forEach((i) => {
      // 临时保存用id
      if (route.query.order_sn) {
        if (i.id == goods.id) {
          i.text = ''
          i.pic = detailsImg
          // 重新添加delita
          i.detail.forEach((ite, index,) => {
            i.detail[index].value = obj.value[index].value
            i.detailChinese[index].value = obj.value[index].value
          })

        }
      } else {
        // 提出用购物车id
        if (i.cart_id == goods.cart_id) {
          i.text = ''
          i.pic = detailsImg
          // 重新添加delita
          i.detail.forEach((ite, index,) => {
            i.detail[index].value = obj.value[index].value
            i.detailChinese[index].value = obj.value[index].value
          })

        }
      }

    })
  })
  Statisticalquantity()

}
// 追加商品数据处理
const addToDataProcessing = (addData) => {

  // 将追加的商品数据放入当前列表
  addData.newList.forEach((item) => {
    // 判断是否是同一店铺，是的话将商品加入同一店铺下,因为不同种类id不同所以不用判断种类
    console.log(item);
    let isSame = false
    orderdata.value.detail.forEach((jtem) => {
      if (item.shop_name == jtem.shop_name) {
        item.list.forEach((etem) => {
          jtem.list.push(etem)
          isSame = true
        })
      }
    })
    if (isSame == false) {
      orderdata.value.detail.push(item)
    }
  })
  calculateOrder()
  Statisticalquantity();
}
// 点击删除图片删除
const deleteitem = (id) => {
  cartid.value = id
  showdelete.value = true
}

// 确认 删除函数
const confirmdelete = () => {
  if (showedit.value == false || cartid.value != '') {
    // 说明是单个删除
    orderdata.value.detail.forEach((item, ind) => {
      console.log(item);
      item.list = item.list.filter((i) => i.cart_id != cartid.value)
      if (item.list.length == 0) {
        orderdata.value.detail.splice(ind, 1)
      }
    })
    showdelete.value = false
    cartid.value = ''
    calculateOrder()
    Statisticalquantity()
  } else {
    // 说明是编辑批量删除 如果
    Selectedarr.value.forEach((id) => {
      orderdata.value.detail.forEach((item, ind) => {

        item.list = item.list.filter((i) => i.cart_id != id)
        if (item.list.length == 0) {
          orderdata.value.detail.splice(ind, 1)
        }
      })
    })
    showdelete.value = false
    calculateOrder()
    Statisticalquantity()
  }

}
// 输入框失焦添加备注
const inputblur = async (item) => {

  if (item.user_postscript !== "") {
    const res = await proxy.$api.goodsCartPostscript({
      cart_id: item.cart_id,
      user_postscript: item.user_postscript,
    });
    if (res.code != 0) {
      return
    }
  }
};
// 单选触发
const goodscheckboxchange = () => {
  Statisticalquantity()
}
// 全选触发
const allcheckchange = () => {
  orderdata.value.detail.forEach((item) => {
    item.list.forEach((i) => {
      i.goodschecked = allchecked.value
    })

  })
  Statisticalquantity()
}
// 加入商品库弹窗
const addproduct = () => {
  let idarr = []
  orderdata.value.detail.forEach((item) => {
    item.list.forEach((i) => {

      idarr.push(i.cart_id)
    })
  })
  // 商品id
  console.log(idarr);

  let ids = idarr.join(",")

  additiveproductdom.value.open(ids)
}
// // 去除上双引号
// const RemoveDoublequotationmarks = (value) => {
//   value = value.replace(/^"|"$/g, '')
//   return value
// }
// 点击删除和加入商品库触发
const Operation = async (type) => {
  // delete  删除 add 加入商品库
  if (Selectedarr.value.length == 0) {

    showToast(proxy.$fanyi('请选择产品'))
    return
  }
  if (type == 'delete') {

    showdelete.value = true
  } else {

    //  说明是添加到商品库 循环筛选选中的数据
    let data = [] // 数组
    Selectedarr.value.forEach((id) => {
      orderdata.value.detail.forEach((item,) => {
        item.list.forEach((i) => {
          if (i.cart_id == id) {

            console.log(i);
            let obj = {
              shop_type: i.shop_type,
              goods_id: i.goods_id,
              goods_title: i.goods_title,
              shop_id: item.shop_id,
              shop_name: item.shop_name,
              img_url: i.pic,
              price_range: i.price_range,
              detailChinese: i.detailChinese,
              specification_checked: i.detailChinese,
              option: i.option,
            }
            data.push(obj)
          }

        })




      })
    })
    console.log(data);
    const res = await proxy.$api.favoriteInventoryBatchSave({
      data: JSON.stringify(data)
    })
    console.log(res);
    if (res.code != 0) {
      showFailToast(proxy.$fanyi(res.msg))
      return
    }
    showToast(proxy.$fanyi('加入商品库成功'))

  }
}

/**
 * 提出订单 / 临时保存
 * @param {Number} type 10=临时保存（不强制地址）；20=正式提出（必须选合法地址）
 */
const Placeanorder = async (type) => {
  // 正式提出必须先选好收货地址，且格式与支付页一致；临时保存允许先存草稿
  if (type == 20 && !checkAddressSelected()) return

  orderdata.value.logistics = logistics.value
  orderdata.value.client_remark = client_remark.value
  let datas = {
    status: type,
    data: JSON.stringify(orderdata.value),
  }
  // 有选中地址时才带 address_id（临时保存也可能已经选了，一并提交）
  if (address_id.value) {
    datas.address_id = address_id.value
  }
  const res = await proxy.$api.orderCreate(datas)
  if (res.code !== 0) {
    showFailToast(res.msg)
    return
  }
  if (type == 10) {

    proxy.$fun.toPage('/user/order?status=temporary')

  } else if (type == 20) {

    let arr = orderdata.value.detail.reduce((acc, item) => {
      item.list.forEach((i) => {
        acc.push(i)
      })
      return acc
    }, [])
    console.log(arr);
    store.commit('savegoodslist', arr)

    // proxy.$fun.toPage('/successpage?order_sn=' + orderdata.value.order_sn)
    proxy.$router.push({
      path: '/successpage',
      query: {
        order_sn: orderdata.value.order_sn,
        type: 'temporary'
      }
    })
  }
}
</script>
<style lang="scss">
.van-icon-cross {
  color: #333;
  font-weight: 500;
  font-size: 18px;
}

#deletedialong {
  width: 295px;
  height: 179px;

  border-radius: 8px;

  .van-dialog__header {
    width: 100%;
    border: 1px solid #dbdbdb;
    height: 50px;

    display: flex;
    margin: 0;
    padding: 0px;
    justify-content: space-between;
    padding-right: 10px;
    padding-left: 20px;
    align-items: center;

    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 20px;
    }

    img {
      width: 24px;
      height: 24px;
    }
  }

  .van-dialog__content {
    width: 100%;
    height: 58px;
    display: flex;
    align-items: center;

    p {
      display: flex;

      width: 100%;
      padding: 0 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 18px;
    }
  }

  .deletefooter {
    width: 100%;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;

    .delete,
    .queren {
      min-width: 120px;
      min-height: 40px;
      background: #ff730b;
      border-radius: 6px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .cancel {
      width: 120px;
      height: 40px;
      background: #f2f2f2;
      border-radius: 6px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 20px;
    }
  }
}
</style>
<style lang='scss' scoped='scoped'>
@import "@/style/scss/mixin.scss";

// 选择框样式
.checkbox-box {


  width: 12px;
  height: 12px;
  padding: 0px;
  margin: 0px;
  border-radius: 2px;
  border: 1px solid #dedede;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin-right: 10px;

  border: 1px solid #ccc;
  border-radius: 3px;
  outline: none;
  cursor: pointer;
  position: relative;
}

input[type="checkbox"]:checked {
  background: #ff730b;
  border-color: #ff730b;
  border: 1px solid#ff730b;
}

input[type="checkbox"]::before {
  position: absolute;
  top: -2px;
  left: -1px;
  content: "\2713";
  /* Unicode编码，表示对号 */
  display: inline-block;

  width: 12px;
  height: 12px;

  text-align: center;
  font-size: 14px;
  opacity: 0;
  color: #ffffff;
  /* 对号的颜色 */
  font-weight: bold;
  transform: scale(0.8, 0.5);
  /* 缩放 */
  transition: transform 0.2s ease-in-out;
  /* 缩放过渡效果 */
}

input[type="checkbox"]:checked::before {
  opacity: 1;
}

.headBox {
  h3 {
    font-size: 14px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #030303;
    line-height: 20px;
  }

  p {
    font-size: 10px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #030303;
    line-height: 14px;
    zoom: 0.9;
  }
}

.bianji {
  font-size: 12px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: #030303;
  line-height: 24px;
}

.placeanorder {
  width: 100%;
  background: #F6F6F6;
  height: calc(100vh - 44px);
  padding: 10px;
  padding-bottom: 118px;
  overflow-y: scroll;

  .shoplist {
    position: relative;

    background: #FFFFFF;
    border-radius: 6px;
    border: 0.5px solid #E2E2E2;
    max-height: 337px;
    overflow: hidden;
    transition: max-height 0.5s;
    padding-bottom: 30px;


    .shopitem {
      padding: 15px;
      border-bottom: 0.5px solid #DBDBDB;
      box-sizing: border-box;

      h3 {
        font-size: 12px;
        font-family: ArialMT;
        color: #222222;
        line-height: 18px;
        margin-bottom: 15px;
      }

      .gooditem {
        width: 100%;
        min-height: 230px;

        width: 100%;

        .Content {
          width: 100%;
          height: 80px;
          display: flex;
          align-items: center;

          margin-bottom: 5px;

          .img-box {

            width: 80px;
            height: 80px;
            margin-right: 10px;
            border-radius: 4px;

            :deep().van-image {
              width: 80px;
              height: 80px;
              border-radius: 4px;
            }

            :deep().van-image__img {
              border-radius: 4px;
            }
          }

          .rightgoodsinfo {
            flex: 1;
            height: 100%;

            // 描述
            .Description {
              height: 32px;
              display: flex;
              justify-content: space-between;
              margin-bottom: 5px;
              align-items: center;

              .text {
                height: 32px;
                font-size: 12px;
                font-family: ArialMT;
                color: #222222;
                line-height: 16px;

                overflow: hidden;
                text-overflow: ellipsis;
                word-break: break-all;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
              }

              img {
                width: 24px;
                height: 24px;
                margin-left: 10px;
              }
            }

            .Commodityspecification {
              padding: 0 5px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 179px;
              height: 20px;
              background: #f6f6f6;
              border-radius: 4px;
              margin-bottom: 5px;

              p {
                align-items: center;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                // zoom: 0.9;
                font-size: 12px;
                font-family: ArialMT;
                color: #666666;
                line-height: 22px;
                zoom: 0.9;
              }

              img {
                margin-left: 10px;
                width: 8px;
                height: 4px;
              }
            }

            .price {
              height: 18px;
              font-size: 12px;
              font-family: ArialMT;
              color: #222222;
              line-height: 18px;

              .dollar,
              .RMB {
                font-size: 12px;
                font-family: ArialMT;
                color: #222222;
                line-height: 18px;
              }
            }
          }
        }

        // 总价
        .totalprice {
          width: 100%;
          height: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;

          .left-price {
            display: flex;
            align-items: center;
            height: 30px;

            .title {
              height: 18px;
              font-size: 12px;
              font-family: ArialMT;
              color: #222222;
              line-height: 16px;
              display: flex;
              margin-right: 5px;
            }

            .dollar {
              margin-right: 2px;
            }

            .dollar,
            .RMB {
              height: 18px;
              font-size: 12px;
              font-family: Arial-BoldMT, Arial;
              font-weight: 600;
              color: #ff730b;
              line-height: 18px;


            }
          }

          .right-input {
            width: 100px;
            height: 30px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid #222222;
            display: flex;
            align-items: center;
            justify-content: center;

            :deep().van-haptics-feedback {
              width: 22px;
              height: 22px;
              background: #f2f2f2;
              border-radius: 2px;
            }

            :deep().van-stepper__minus--disabled {
              width: 22px;
              height: 22px;
              background: #f2f2f2;
              border-radius: 2px;
            }

            :deep().van-stepper {
              height: 22px;
              display: flex;
              align-items: center;
            }

            :deep().van-stepper__input {
              width: 40px;
              height: 16px;
              font-size: 12px;

              font-family: ArialMT;
              background-color: #fff;
            }
          }
        }

        // 附加服务
        .Additionalservices {
          padding: 0 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          height: 40px;
          background: #FFFFFF;
          border-radius: 6px;
          border: 0.5px solid #DEDEDE;
          margin-bottom: 10px;

          p {


            width: 275px;


            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 12px;
            font-family: ArialMT;
            color: #666666;

          }

          .optiontext {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #222222;
            line-height: 20px;
            align-items: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: flex;


            span {
              font-size: 14px;
              line-height: 20px;
              margin-right: 5px;
            }

          }

          img {
            margin-left: 10px;
            width: 20px;
            height: 20px;
          }


        }

        // 备注

        .Remarks {
          // width: 325px;
          // height: 40px;
          // background: #FFFFFF;
          border-radius: 6px;
          border: 0.5px solid #dedede;

          margin-bottom: 14px;

          input {
            width: 100%;
            height: 40px;
            background: #ffffff;
            border-radius: 6px;
            border: none;
            font-size: 12px;
            font-family: ArialMT;
            padding-left: 10px;
            line-height: 18px;

          }

          input:placeholder {
            font-size: 12px;
            font-family: ArialMT;
            color: #C0C4CC;
          }
        }
      }

      .borderbottom {
        border-top: 1px dashed #dbdbdb;

        padding-top: 14px;

      }
    }



    /* Open / Put away 底栏：贴齐底边；圆角交给父级 overflow 裁剪，避免双圆角留白缝 */
    .foot-box {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      width: auto;
      height: 34px;
      box-sizing: border-box;
      background: #FFFFFF;
      box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.04);
      border-radius: 0; /* 父级 .shoplist 已有 border-radius + overflow:hidden */
      border-top: 0.5px solid #E2E2E2;
      padding: 0 15px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      div {
        display: flex;
        align-items: center;
      }

      span {
        font-size: 10px;
        font-family: ArialMT;
        color: #222222;
        line-height: 14px;
      }

      img {
        margin-left: 5px;
        width: 12px;
        height: 7px;
      }


    }
  }

  .maxheight {
    max-height: 10000000px;
    transition: max-height 0.5s;
  }
}

// 备注
.orderRemarks {
  min-height: 193px;
  padding: 15px;
  margin-top: 10px;
  background: #FFFFFF;
  border-radius: 6px;
  border: 0.5px solid #E2E2E2;

  h2 {
    height: 18px;
    font-size: 12px;
    font-family: PingFang-SC-Semibold, PingFang-SC;
    font-weight: 600;
    color: #222222;
    line-height: 18px;
    margin-bottom: 10px;
  }

  p {
    height: 28px;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    margin-bottom: 15px;
  }

  .beizhu {
    height: 92px;
    width: 100%;
    background: #FFFFFF;
    padding: 10px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #C0C4CC;
    line-height: 18px;
    border-radius: 6px;
    border: 0.5px solid #DEDEDE;
    color: #C0C4CC;
  }

}

.footercaozuolan {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 108px;

  background: #FFFFFF;

  .Additionalproductbox {

    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    box-shadow: inset 0px 0.5px 0px 0px #E2E2E2;
    padding: 0 20px;

    .leftproduct {
      display: flex;

      img {
        width: 12px;
        height: 12px;
        margin-right: 3px;
      }

      span {
        font-size: 12px;
        font-family: ArialMT;
        color: #222222;
        line-height: 16px;
        zoom: 0.9;
      }

    }

    .quantity {
      font-size: 12px;
      font-family: ArialMT;
      color: #666666;
      line-height: 16px;
      zoom: 0.9;

      span {
        color: #222222;
        font-weight: 600;
      }
    }
  }

  .tichu-box {
    display: flex;
    height: 68px;
    justify-content: space-between;
    box-shadow: inset 0px 0.5px 0px 0px #E2E2E2;
    align-items: center;
    padding: 0 20px;

    .totalprice {
      display: flex;

      .title {
        height: 20px;
        font-size: 12px;
        font-family: ArialMT;
        color: #666666;
        line-height: 15px;
        margin-right: 5px;
      }

      .price {
        .dollar {
          margin-bottom: 2px;
          height: 20px;
          font-size: 14px;
          font-family: Arial-BoldMT, Arial;
          font-weight: 600;
          color: #FF730B;
          line-height: 20px;
        }

        .RMB {
          height: 16px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 16px;
        }
      }



    }

    .Temporarypreservation {
      width: 50px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      text-align: center;


      img {
        width: 15px;
        height: 15px;
        margin-bottom: 5px;

      }



      p {
        margin-top: 2px;
        height: 20px;
        font-size: 12px;
        font-family: ArialMT;
        color: #666666;
        line-height: 10px;
        zoom: 0.9;
      }
    }

    .Placeanorder {
      width: 120px;
      height: 48px;
      background: #FF730B;
      border-radius: 6px;
      font-size: 14px;
      font-family: ArialMT;
      color: #FFFFFF;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 20px;
    }
  }
}

// 编辑底部操作栏
.editfooterbox {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 108px;

  background: #FFFFFF;

  .allcheckbox {

    height: 40px;
    background: #FFFFFF;
    box-shadow: inset 0px 0.5px 0px 0px #E2E2E2;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left-check {
      font-size: 10px;
      font-family: ArialMT;
      color: #666666;

      display: flex;
      align-items: center;
    }

    .checkbox-box {
      margin-right: 5px;
    }

    .Totalquantity {
      font-size: 10px;
      font-family: ArialMT;
      color: #666666;
      line-height: 16px;

      span {
        color: #222222;
        font-weight: 600;
      }
    }


  }

  .caozuobox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 68px;
    background: #FFFFFF;
    box-shadow: inset 0px 0.5px 0px 0px #E2E2E2;
    padding: 0 20px;

    .delete {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 160px;
      height: 48px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 20px;
      background: #608BFF;
      border-radius: 6px;
    }

    .addgoods {
      display: flex;

      justify-content: center;
      width: 160px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 20px;
      height: 48px;
      background: #FF730B;
      border-radius: 6px;
      align-items: center;
    }
  }

}
</style>